module.exports = __webpack_public_path__ + "static/media/ok.bb90c79c.png";